import React from 'react'

import CustomAlert from '../../components/Alerts/CustomAlert'

const OlcuAlert = () => {
  return (
    <CustomAlert
      text=' Aşağıdaki hasır tel ölçüleri örnek ölçülerdir. Sadece fikir vermek için yazılmıştır. İhtiyacınıza göre istediğiniz her ölçüde hasır
    tel imalatı yapılmaktadır.'
    />
  )
}
export default OlcuAlert
